import { TextLogo } from '@/shared/components/text-logo'

export default function QuizLogoHeader() {
  return (
    <div className="mx-auto max-w-3xl pb-4">
      <TextLogo />
    </div>
  )
}
